import React from 'react';
import { Typography, Switch } from 'antd';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';
import type { CSSProperties } from 'react';
import type { BaseFieldProps } from '../../../types/form-renderer';
import type { SwitchField as SwitchFieldType } from '../../../types/templates';

const { Text } = Typography;

type Props = BaseFieldProps<SwitchFieldType> & { customStyles?: CSSProperties };

export const SwitchField: React.FC<Props> = ({
  field,
  value,
  onChange,
  commonStyle,
  labelStyle,
  error,
  customStyles
}) => {
  const { spacing } = useResponsiveSizes();

  const mergedStyle = { ...commonStyle, ...customStyles };
  const valueType = field.valueType ?? 'boolean';

  const checked =
    typeof value === 'boolean' ? value : value === 'si' ? true : value === 'no' ? false : !!field.defaultValue;

  const handleChange = (newChecked: boolean) => {
    onChange(valueType === 'string' ? (newChecked ? 'si' : 'no') : newChecked);
  };

  return (
    <div style={{ ...mergedStyle, flexDirection: 'row', alignItems: 'center', gap: spacing.sm }}>
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase', margin: 0 }}>
        {field.label}
      </Text>
      <Switch
        checked={checked}
        onChange={handleChange}
        style={{
          zIndex: 10,
          background: checked ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' : undefined
        }}
      />
      {error && (
        <Text type='danger' style={{ fontSize: 12, marginLeft: 8 }}>
          {error}
        </Text>
      )}
    </div>
  );
};
